export default {"src":"/_next/static/media/community.6c1d4b59.svg","height":689,"width":532,"blurWidth":0,"blurHeight":0};